// Keep provider completion separate from confirmed signature evidence.
export type SigningState =
  | 'preparing'
  | 'preparation_failed'
  | 'creation_uncertain'
  | 'awaiting_signature'
  | 'signed'
  | 'completion_reported'
  | 'declined'
  | 'expired'
  | 'voided'
  | 'failed'
  | 'deleted'
  | 'provider_state_unknown'

export const signingStateLabels: Record<SigningState, string> = {
  preparing: 'Preparing',
  preparation_failed: 'Preparation incomplete',
  creation_uncertain: 'Status unavailable',
  awaiting_signature: 'Awaiting signature',
  signed: 'Signed',
  completion_reported: 'Confirming signature',
  declined: 'Declined',
  expired: 'Expired',
  voided: 'Voided',
  failed: 'Failed',
  deleted: 'Deleted',
  provider_state_unknown: 'Status unavailable',
}

export interface CollectedDocument {
  id: string
  formKey: string
  formName: string
  configurationName: string
  memberName: string
  state: SigningState
  createdAt: string
  signedAt?: string
  memberId?: string
  configurationId?: string
  activity: {
    label: string
    at: string
    callId?: string
    reason?: string
    actor?: string
  }[]
}

export function filterDocuments(
  documents: CollectedDocument[],
  filters: Record<string, unknown>
): CollectedDocument[] {
  return documents.filter((document) => {
    for (const key of ['memberName', 'configurationName'] as const) {
      const query = filters[key]
      if (
        typeof query === 'string' &&
        !document[key].toLowerCase().includes(query.trim().toLowerCase())
      )
        return false
    }
    for (const key of ['formKey', 'state'] as const) {
      const options = filters[key]
      if (
        Array.isArray(options) &&
        options.length &&
        !options.includes(document[key])
      )
        return false
    }
    const range = filters.createdAt
    if (Array.isArray(range) && range[0]) {
      const start = new Date(range[0])
      const end = range[1] ? new Date(range[1]) : new Date(start)
      end.setHours(23, 59, 59, 999)
      const created = new Date(document.createdAt)
      if (created < start || created > end) return false
    }
    return true
  })
}

export function documentDate(value: string): string {
  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
